import {
  setFoldersJson,
  updateAllDocs,
  updateFetchedFolders,
  updateMatchingTickets,
  updateTicketDetail,
  updateTicketLogs,
} from '../../store';
import {
  fetchFoldersJsonData,
  fetchTicketDetail,
  fetchTicketLogs,
  fetchFolderDocuments,
  fetchMatchingTickets,
  fetchAllActiveDocsInDivision,
  postDivisionSupervisor,
  fetchArchiveDocuments,
} from '../calls';

export const fetchFolders = async (accessToken, dispatch) => {
  const foldersJson = await fetchFoldersJsonData(accessToken);
  const folders = foldersJson.folders || [];
  setFoldersJson(folders, dispatch);
};

export const fetchLogs = async (fetchPrefix, user, dispatch) => {
  updateTicketLogs({}, dispatch);
  const ticketLogs = await fetchTicketLogs(fetchPrefix, user, dispatch);
  updateTicketLogs(ticketLogs, dispatch);
};

export const fetchMatches = async (ticketString, token, dispatch) => {
  updateMatchingTickets({}, dispatch);
  const matches = await fetchMatchingTickets(ticketString, token, dispatch);
  updateMatchingTickets(matches, dispatch);
};

export const fetchTicket = async (ticketID, token, dispatch) => {
  const ticket = await fetchTicketDetail(ticketID, token, dispatch);
  updateTicketDetail(ticket, dispatch);
};

export const fetchAllDocs = async (
  allDocs,
  fetchedFolders,
  folderOptions,
  accessToken,
  dispatch,
  updateFoldersLoaded
) => {
  folderOptions = folderOptions.filter((folder) => folder.value !== '');
  let resultsObj = await fetchAllActiveDocsInDivision(
    allDocs,
    fetchedFolders,
    folderOptions,
    accessToken,
    dispatch,
    updateFoldersLoaded
  );
  updateFetchedFolders(resultsObj.fetchedFolders, dispatch);
  updateAllDocs(resultsObj.results, dispatch);
};

export const fetchFolderDocs = async (
  allDocs,
  fetchedFolders,
  folderID,
  accessToken,
  dispatch
) => {
  let fetchedFoldersClone = { ...fetchedFolders };
  const folderIsInState = fetchedFoldersClone[folderID];
  let docsObj;
  let archiveObj;
  const updatedFolder = {};
  let lastSeq = null;
  const allDocsObj = {};

  if (fetchedFoldersClone[folderID]) {
    lastSeq = fetchedFoldersClone[folderID]?.lastSeq;
    if (fetchedFoldersClone[folderID]?.archiveFetched) {
      archiveObj = { resultsArray: [] };
    } else {
      archiveObj = await fetchArchiveDocuments(
        folderID,
        accessToken,
        dispatch
      );
    }
  } else {
    archiveObj = { resultsArray: [] };
  }
  docsObj = await fetchFolderDocuments(
    folderID,
    accessToken,
    dispatch,
    lastSeq,
    !folderIsInState ? true : false
  );

  // Create constant time lookup for allDocs
  Array.isArray(allDocs) &&
    allDocs.forEach((doc) => {
      if (doc.id) {
        allDocsObj[doc.id] = doc;
      }
    });

  if (docsObj && docsObj.updatesArray && !folderIsInState) {
    // Create constant time lookup for results
    const resultsObj = {};
    docsObj.resultsArray.forEach((result) => {
      if (result.id) {
        resultsObj[result.id] = result;
      }
    });

    docsObj.updatesArray.forEach((doc) => {
      const oldDoc = resultsObj[doc.id];
      const baseDoc = allDocsObj[doc.id];

      const baseDocRev = baseDoc && baseDoc.doc._rev;
      const oldDocRev = oldDoc && oldDoc.doc._rev;
      const newDocRev = doc.doc._rev;
      if (
        baseDocRev &&
        newDocRev &&
        parseInt(newDocRev.split('-')[0]) > parseInt(baseDocRev.split('-')[0])
      ) {
        // If the updated document is of a higher revision than the one in
        // allDocs then replace it and delete the version from the new results
        allDocsObj[doc.id] = doc;

        if (oldDoc) {
          delete resultsObj[doc.id];
        }
      } else if (
        oldDocRev &&
        newDocRev &&
        parseInt(newDocRev.split('-')[0]) > parseInt(oldDocRev.split('-')[0])
      ) {
        // If the updated document is of a higher revision than the one in
        // the results array, replace it and delete from allDocs.
        resultsObj[doc.id] = doc;

        if (baseDoc) {
          delete allDocsObj[doc.id];
        }
      } else if (!oldDocRev && !baseDocRev) {
        // If only the updated document revision exists, add it to the
        // results array
        resultsObj[doc.id] = doc;
      }
    });

    // Legacy code has resultsArray spreat to create final array, thus it is
    // required to assign the updated results to the resultsArray
    docsObj.resultsArray = Object.values(resultsObj);
  } else if (docsObj && docsObj.resultsArray && folderIsInState) {
    docsObj.resultsArray.forEach((doc) => {
      const baseDoc = allDocsObj[doc.id];

      const oldDocRev = baseDoc && baseDoc.doc._rev;
      const newDocRev = doc.doc._rev;
      if (
        (oldDocRev &&
          newDocRev &&
          parseInt(newDocRev.split('-')[0]) >
            parseInt(oldDocRev.split('-')[0])) ||
        !oldDocRev
      ) {
        allDocsObj[doc.id] = doc;
      }
    });
    docsObj.resultsArray = [];
  }
  const results = [
    ...Object.values(allDocsObj),
    ...docsObj.resultsArray,
    ...archiveObj.resultsArray,
  ];
  updatedFolder[folderID] = {
    lastSeq: docsObj.lastSequence,
    archiveFetched: true,
  };
  Object.assign(fetchedFoldersClone, updatedFolder);
  updateFetchedFolders(fetchedFoldersClone, dispatch);
  updateAllDocs(results, dispatch);
};

export const postNewOnCall = async (lanId, division, token, dispatch) => {
  const foldersJson = await postDivisionSupervisor(
    lanId,
    division,
    token,
    dispatch
  );
  if (foldersJson.error) {
    return foldersJson.error;
  } else {
    const folders = foldersJson.folders || [];
    setFoldersJson(folders, dispatch);
  }
};
